export class AuthenticationConfig {
    public logoutRedirectUri!: string;
}